module.exports = __webpack_public_path__ + "static/img/dialog1.b3d2235.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/common/dialog1.png
// module id = TUf8
// module chunks = 7